/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ fleets: NonNullable<unknown>, expected: NonNullable<unknown> }} Rmf_Degraded_BodyInputs */

const en_rmf_degraded_body = /** @type {(inputs: Rmf_Degraded_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Only ${i?.fleets} fleet(s) out of ${i?.expected} expected were registered. Some tasks may fail. You can retry the startup, or continue in degraded mode.`)
};

const fr_rmf_degraded_body = /** @type {(inputs: Rmf_Degraded_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Seules ${i?.fleets} flotte(s) sur ${i?.expected} attendues se sont enregistrées. Certaines tâches risquent d'échouer. Vous pouvez relancer le chargement, ou continuer en mode dégradé.`)
};

const ms_sg2_rmf_degraded_body = /** @type {(inputs: Rmf_Degraded_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hanya ${i?.fleets} armada daripada ${i?.expected} dijangka telah didaftarkan. Sesetengah tugasan mungkin gagal. Anda boleh mencuba semula permulaan, atau teruskan dalam mod terjejas.`)
};

/**
* | output |
* | --- |
* | "Only {fleets} fleet(s) out of {expected} expected were registered. Some tasks may fail. You can retry the startup, or continue in degraded mode." |
*
* @param {Rmf_Degraded_BodyInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const rmf_degraded_body = /** @type {((inputs: Rmf_Degraded_BodyInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rmf_Degraded_BodyInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rmf_degraded_body(inputs)
	if (locale === "fr") return fr_rmf_degraded_body(inputs)
	return ms_sg2_rmf_degraded_body(inputs)
});